import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { IconLoader } from 'common/IconLoader';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import styles from './ActionTwoHopModalBannerContainer.module.css';
import WarningBox from 'components/shared/WarningBox/WarningBox';

const CANCEL_BANNER_MESSAGE = 'This Alignment progress has been cancelled by the User.';

const ActionTwoHopModalBannerContainer = ({ action }) => {
  const twoHopCancelStatus = useSelector(
    (store) => store.ui.actionsPage.twoHopCancelStatusDictionary?.[action?.commissioningId]
  );
  const customStatus = action?.customStatus?.status?.toLowerCase();
  const customStatusMessage = action?.customStatus?.message || 'Unknown';
  const inError = ['error', 'failed'].includes(customStatus);
  const inWarning = ['cancelled'].includes(customStatus) || twoHopCancelStatus?.entityExists === true;

  let bannerComponent = null;

  if (inError) {
    bannerComponent = (
      <div className={styles.error_banner_container} data-tip={customStatusMessage}>
        <IconAndText
          img={IconLoader.icon_error_s}
          hoverImg={IconLoader.icon_error_s}
          text={customStatusMessage}
          customClass={styles.icon_and_text}
        />
      </div>
    );
  } else if (inWarning) {
    const warningMessages = inWarning && customStatus?.message ? customStatus.message : CANCEL_BANNER_MESSAGE;
    bannerComponent = <WarningBox className={styles.warning_banner_container} warningMessages={warningMessages} />;
  }

  return bannerComponent;
};

export default memo(ActionTwoHopModalBannerContainer);
